<template>
  <section id="poi" class="poi">
    <Hero
      :config="$props.config"
      :loc="$props.config.title"
      :wknd="$props.wknd"
      :title="title"
      :params="[]"
    />
    <div class="container">
      <div class="row">
        <div class="col-1 hidden-sm"></div>
        <div class="col-10 sec">
          <Plist
              :render="false"
              :id="$props.id"
              :title="'Holiday cottages near ' + $props.config.title"
              :loc="$props.loc.name"
              :pageNo="$props.pageNo"
              :nights="3"
              :date="$props.wknd"
              :type="'poi'"
              :config="$props.config"
              :page="$props.page"
              :crumbs="$props.crumbs"
              @updateParentData="updateParentData"
          />
          <ButtonCTA
              :text="'See properties nearby ' + $props.config.title"
              :link="$props.searchLink"
              :colour="'org'"
          />
          <div class="inner">
            <LinkList
              :links="featureLinks"
              :title="'Search cottages by features'"
              :sub="'Search by the most popular features at this location'"
              :icon="true"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="$props.seoText.upper || $props.seoText.lower">
      <FullImage
        :image="$props.config.image_url"
        :mobileImage="$props.config.mobile_image_url"
        :heading="'Why choose a cottage nearby ' + $props.config.title"
      />
      <div class="container">
        <div class="row">
          <div class="col-1 hidden-sm"></div>
          <div class="col-10 wrap">
            <div class="inner">
              <Content
                :htmlText="$props.seoText.upper"
              />
              <Content
                 :htmlText="$props.seoText.lower"
              />
              <ButtonCTA
                :text="'See properties in ' + $props.loc.name"
                :link="$props.searchLink"
                :colour="'org'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$props.config.html_block_1">
      <FullImage
          :image="$props.config.image_url"
          :mobileImage="$props.config.mobile_image_url"
          :heading="'Why choose a cottage nearby ' + $props.config.title"
      />
      <div class="container">
        <div class="row">
          <div class="col-1 hidden-sm"></div>
          <div class="col-10 wrap">
            <div class="inner">
              <Content
                  :htmlText="$props.config.html_block_1"
              />
              <ButtonCTA
                :text="'See properties in ' + $props.loc.name"
                :link="$props.searchLink"
                :colour="'orgWire'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$props.config.html_block_2">
      <FullImage
          :image="$props.config.image_url"
          :mobileImage="$props.config.mobile_image_url"
          :heading="'Why choose a cottage nearby ' + $props.config.title"
      />
      <div class="container">
        <div class="row">
          <div class="col-1 hidden-sm"></div>
          <div class="col-10 wrap">
            <div class="inner">
              <Content
                :htmlText="$props.config.html_block_2"
              />
              <ButtonCTA
                :text="'See properties in ' + $props.loc.name"
                :link="$props.searchLink"
                :colour="'orgWire'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-1 hidden-sm"></div>
        <div class="col-10 map-container">
          <h2>{{$props.loc.name }} tourist map</h2>
          <p>See what's nearby {{ $props.config.title }}</p>
        </div>
      </div>
    </div>
    <Map
      :map="map"
      :page="'poi'"
      :nearby="$props.nearby"
      :props="propLatLngs"
    />
    <div class="container">
      <div class="row">
        <div class="col-1 hidden-sm"></div>
        <div class="col-10 wrap">
          <imgBlocks
            :imgs="blogs"
            :display="'grid'"
            :title="'Our blog'"
            :sub="'Read about things to do near ' + $props.loc.name + ' to make the most of your getaway'"
            v-if="blogs.length > 0"
          />
          <LinkList
            :links="destLinks"
            :title="'Other popular destinations'"
            :sub="'Check out other amazing locations'"
            :icon="false"
          />
          <reviews
            :reviews="data.top_reviews"
            :title="'Reviews'"
            :sub="'What our customers say about their holidays'"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Hero from 'comp_seo/hero.vue'
import LinkList from 'shared/linkList.vue'
import FullImage from 'shared/fullImage.vue'
import Plist from 'shared/properties.vue'
import Content from 'shared/content.vue'
import ButtonCTA from 'shared/buttonCTA.vue'
import Map from 'shared/mapCustom.vue'
import imgBlocks from 'comp_seo/image_block.vue'
import reviews from 'comp_seo/reviews.vue'

export default {
  data: function () {
    let cms = this.$props.loc.cms_json;
    return {
      data: {
          top_reviews: []
      },
      featureLinks: this.$props.links.feat,
      destLinks: this.$props.links.dest,
      map: {
        coords: [this.$props.page.lng, this.$props.page.lat],
        zoom: 10,
        minZoom: 3,
        maxZoom: 15
      },
      blogs: typeof cms !== "undefined" && cms !== null ? cms[0].posts : [],
      propLatLngs: [],
      title: ['Holiday cottages near ', this.$props.config.title, ' to rent']
    }
  },
  props: {
    id: Number,
    config: Object,
    page: Object,
    pageNo: Number,
    nearby: Array,
    loc: Object,
    crumbs: Array,
    links: Object,
    seoText: Object,
    wknd: String,
    searchLink: String
  },
  components: {
     Hero, LinkList, FullImage, Plist, Content, Map, imgBlocks, reviews, ButtonCTA
  },
  watch: {
      'data.properties': function (newV, oldV) {
          let props = newV, all = [];
          for (let i = 0; i < props.length; i++) {
            let prop = props[i];
            all.push([prop.lat, prop.lng, prop.name, "prop"]);
          }
          this.propLatLngs = all;
      }
  },
  methods: {
      updateParentData (data) {
          this.data = data;
      }
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.container {
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
  }

.poi {
  background-repeat: repeat-y;
  background-position: 50%;
  width: 100%;
  background-size: 100%;
}

.map-container {
  padding: 1.25rem;
}


.wrap,
.inner {
  box-sizing: border-box;
}

.wrap {
  padding: 0 1.25rem;
}

@media #{$desktop} {
  .map-container {
    padding: 0;
    margin: 1.25rem 1.25rem 0;
  }

  .inner {
     width: 100%;
  }
}

</style>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.plist {
  margin: 1.25rem;
}

.inner.poi,
.image-block{
  margin: 1.25rem 0;
}

.hero {
  margin: -4.938rem 0 0 0;
}

.reviews {
  margin: 2.5rem 0 5rem;
}

@media #{$desktop} {

  .hero {
    margin: -6.275rem 0 1.25rem 0;
  }
}

</style>